import React, { useState } from 'react';
import {Button, message, Table, Popconfirm, Alert, Tooltip} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {DeleteFilled, ArrowRightOutlined} from "@ant-design/icons";
import { DateBlock } from "../../../../ui/date";
import { GetAppReleases, DeleteAppRelease } from "../../../../../api/release";

export const ReleaseController = (props) => {
    const queryClient = useQueryClient();
    const params = useParams();
    const nav= useNavigate();

    const [ page, setPage ] = useState(1);
    const [ limit, setLimit ] = useState(30);
    const [ search, setSearch ] = useState('');

    const openUploadReleasePage = () => {
        nav(`/console/${params.developer_id}/app/${params.app_id}/release/new`);
    }

    const openRelease = (release_id) => {
        nav(`/console/${params.developer_id}/app/${params.app_id}/release/${release_id}`);
    }

    const Releases = useQuery(
        ['releases', params.developer_id, params.app_id],
        () => GetAppReleases(params.developer_id, params.app_id, page, limit, search)
    );

    const ReleaseDeleteMutation = useMutation(
        (release_id) => DeleteAppRelease(params.developer_id, params.app_id, release_id),
        {
            onSuccess: (data, vars) => {
                queryClient.invalidateQueries('releases');
                message.success(`Выпуск успешно удален`);
            },
            onError: (e) => {
                console.error(`[ReleaseDeleteMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )


    const columns = [
        {
            title: 'Название',
            key: 'icon',
            render: r => {
                return r.release_name || `[не задан]`
            }
        },
        {
            title: "Версия",
            key: "latest_version",
            render: r => r.version_code,
        },
        {
            title: "Статус",
            key: "status",
            render: r => {
                return r.status;
            }
        },
        {
            title: 'Дата обновления',
            key: 'update_at',
            align: 'center',
            render: r => {
                return <DateBlock date={r.updatedAt} />;
            }
        },
        {
            title: '',
            key: 'actions',
            align: 'center',
            render: r => {
                let extra = [];
                if (r.status === 'Черновик') {
                   extra.push(
                       <Popconfirm
                           title={`Вы уверены, что хотите удалить выпуск?`}
                           okText={'Да, удалить'}
                           cancelText={'Нет'}
                           onConfirm={() => {
                               ReleaseDeleteMutation.mutate(r.id)
                           }}
                       >
                           <Tooltip title={`Удалить выпуск`}><Button
                               icon={<DeleteFilled/>}
                               type={`danger`}
                               shape={`circle`}
                               loading={ReleaseDeleteMutation.isLoading}
                           /></Tooltip>
                       </Popconfirm>
                   );
                }
                if (r.status === 'Черновик') {
                    extra.push(<Tooltip title={`Выпустить приложение`}><Button onClick={() => openRelease(r.id)} type={`primary`} shape={`circle`} icon={<ArrowRightOutlined />} /></Tooltip>);
                }
                return <div className={`table--actions`}>{extra.map(i => {
                   return i;
                })}</div>;
            }
        }
    ];

    return (
        <div className={`dev__layout release--layout`}>
            <div className={`dev__layout--header`}>
                <div className="header__info">
                    <h1>Выпуски</h1>
                    <p>Публикация Вашего приложения в магазине</p>
                </div>
                <div className="header__actions">
                    <Button type={`primary`} onClick={openUploadReleasePage}>Создать выпуск</Button>
                </div>
            </div>
            <Alert
                type={`info`}
                message={`После того как вы загрузите приложение и заполните необходимые данные, Вы сможете отправить приложение на модерацию`}
            />
            <h3>Последние выпуски</h3>
            <div className="dev__layout--content">
            <Table
                locale={{'emptyText': 'У вас еще нет приложений'}}
                loading={Releases.isLoading}
                columns={columns}
                dataSource={Releases?.data?.list || []}
                rowKey={(item) => item.id}
                pagination={{
                    hideOnSinglePage: true,
                }}
            />
            </div>
            <h3>Статистика по выпускам</h3>
            <div className="dev__layout--content">На этапе разработки</div>
        </div>
    );
}



export default ReleaseController;